import { getDefaultOrderTipOptionForSite } from '../../../sales-data/selectors/order-tip-options/get-default-order-tip-option-for-site';
import { OrderTipSelectionType } from '../../types/order-tip-selection-type';
import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from '../order/get-order';
import { getOrderSelections } from '../order/get-order-selections';
import { getOrderSiteId } from '../order/get-order-site-id';
/**
 * Gets the tip of the order.
 */
export const getOrderTipSelection = () => {
    var _a;
    const order = getOrder();
    if (order && !isStandardOrder(order))
        return undefined;
    const { tip } = getOrderSelections();
    if (tip)
        return tip;
    // return default order tip when the order tip has not been set
    return (_a = getPersistedOrderTipSelection(order)) !== null && _a !== void 0 ? _a : getDefaultOrderTipSelection();
};
const getPersistedOrderTipSelection = (order) => {
    if (!(order === null || order === void 0 ? void 0 : order.tip))
        return;
    return {
        type: OrderTipSelectionType.Amount,
        amount: order.tip.amount.valueIncludingTax
    };
};
const getDefaultOrderTipSelection = () => {
    const siteId = getOrderSiteId();
    if (siteId === undefined)
        return undefined;
    const defaultOrderTipOption = getDefaultOrderTipOptionForSite(siteId);
    if (!defaultOrderTipOption)
        return undefined;
    return {
        type: OrderTipSelectionType.Percentage,
        percentage: defaultOrderTipOption.percentage
    };
};
//# sourceMappingURL=get-order-tip-selection.js.map